import { module } from 'modujs';
import gsap from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.slides = Array.from(this.$('slide'))
        this.count = 0;
    }

    init() {
        this.el.addEventListener('mouseenter', () => {
            this.compute()

            clearInterval(this.interval)

            this.changeSlide()
            this.interval = setInterval(this.changeSlide.bind(this), 500)
        })

        this.el.addEventListener('mouseleave', () => {
            clearInterval(this.interval)
        })

        // this.el.addEventListener('mousemove', e => {
        //     const segmentWidth = Math.floor((this.BCR.width / this.slides.length) / 2);
        //     console.log(segmentWidth);
        //     const totalSegments = Math.ceil(this.BCR.width / segmentWidth)

        //     const segmentIndex = Math.floor(e.offsetX / segmentWidth);
        //     const slideIndex = segmentIndex % this.slides.length;

        //     gsap.set(this.slides, { opacity: 0 })
        //     gsap.set(this.slides[slideIndex], { opacity: 1 });
        // })
    }

    changeSlide() {
        this.count++;

        gsap.set(this.slides, { opacity: 0 })
        gsap.set(this.slides[this.count % this.slides.length], { opacity: 1 });
    }

    compute() {
        this.BCR = this.el.getBoundingClientRect();
    }
}
